const allRoutes = {
  login: '/',
  forgotPassword: '/forgot-password',
  dashboard: '/dashboard',
  subAdmin: '/sub-admin',
  userList: '/users',
  verificationRequest: '/verification-request',
  projectsManagements: '/projects-managements',
  materialManagements: '/material-managements',
  stackUpListing: '/stack-up',
  editStackUp: (iStackupId) => `/stack-up/${iStackupId}`,
  viaStructure: '/via-structure',
  cms: '/cms',
  adminLogs: '/admin-logs',
  viaSpan: '/via-spans',
  viaSpanDetail: (iViaSpanId) => `/via-spans/${iViaSpanId}`,
  exploreStackUp: '/explore-stack-up',
  stackUpDetails: '/stack-up-details',
  verification: '/verification',
  projects: '/projects',
  materialListing: '/material-listing'
}
export default allRoutes
